import { render, staticRenderFns } from "./IncluirOrcamentoProcedimentos.vue?vue&type=template&id=1c31d5c4&"
import script from "./IncluirOrcamentoProcedimentos.vue?vue&type=script&lang=js&"
export * from "./IncluirOrcamentoProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports